import {
  Required,
  IsString,
  IsNumber,
  IsArray,
  DataValidator,
  transformKeys,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

interface GetAllFolderItemsResponse {
  folder_list: Array<any>;
}

class AllFolderItemData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Folder name cannot be empty")
  @IsString("Folder name must be a string")
  folderName: string;

  @Required("Create time cannot be empty")
  @IsString("Create time must be a string")
  createTime: string;

  @IsString("Update time must be a string")
  updateTime?: string;

  @IsNumber("User id must be a number")
  userId?: number;

  @IsNumber("Folder id must be a number")
  folderId?: number;

  @IsNumber("Agent id must be a number")
  agentId?: number;

  @IsNumber("Item count must be a number")
  itemCount?: number;

  @IsNumber("Type must be a number")
  type?: number;
}

class GetAllFolderItemsData {
  // @Required("list cannot be empty")
  @IsArray("list must be an array")
  @ValidateNested(AllFolderItemData)
  list: Array<AllFolderItemData>;
}

const transformAndValidateData = (
  response: GetAllFolderItemsResponse
): GetAllFolderItemsData => {
  const transformed = transformKeys(response);
  const data = DataValidator.validateOrThrow(transformed, GetAllFolderItemsData);
  if (!data.list) data.list = [];
  return data;
};

export interface KnowledgeListAgentUserFoldersRequest {
  agentId?: string;
  type?: "" | "video" | "podcast" | "moments" | "post" | "article";
}

export const knowledgeListAgentUserFolders = async ({
  agentId = "",
  type = "",
}: KnowledgeListAgentUserFoldersRequest): Promise<AllFolderItemData[]> => {
  const allowed = ["", "video", "podcast", "moments", "post", "article"] as const;
  const typeMap = { video: '1', podcast: '2', moments: '3', post: '4', article: '5' } as const;

  if (!allowed.includes(type)) {
    throw new Error("Invalid type");
  }
  if (agentId && !type) {
    throw new Error("Invalid type: agentId provided requires type");
  }
  if (type && !(type in typeMap)) {
    throw new Error("Invalid type");
  }

  const params: Record<string, any> = {};
  if (agentId) params.agent_id = agentId;
  if (type) params.type = typeMap[type as keyof typeof typeMap];

  const response = await api.post<GetAllFolderItemsResponse>("/knowledge/list_agent_user_folders", params);
  const data = transformAndValidateData(response.data);
  return data.list;
};